import _ from 'lodash';
import {useEffect} from 'react';
import {useComponentId} from '../../../hooks/useComponentId';
import {useVuplex} from '../../../hooks/useVuplex';
import {getVuplexMessageHandlers, sendPin, sendPinEvent, sendPinUnmount} from '../../../vuplex';

const InAppMapPin = ({
  color,
  hasWebContent,
  iconUrl,
  isHovering, // hovered in web
  label,
  latitude,
  longitude,
  onClick,
  onHoverEnter, // hovered in app
  onHoverExit, // hovered in app
  placeType,
  spaceId,
  tooltip,
}) => {
  const componentId = useComponentId();

  const isGif = /\.gif$/i.test(iconUrl);

  useEffect(() => {
    // console.log('update pin', color,
    //   componentId,
    //   iconUrl,
    //   label,
    //   latitude,
    //   longitude,
    //   placeType,
    //   tooltip,)

    sendPin({
      color,
      componentId,
      hasWebContent,
      label,
      latitude,
      longitude,
      placeType,
      spaceId,
      tooltip,

      ...isGif ? {} : { // Unity can't handle .gif
        iconUrl,
      },
    });

    return () => sendPinUnmount(componentId);
  }, [
    color,
    componentId,
    iconUrl,
    label,
    latitude,
    longitude,
    placeType,
    tooltip,
  ]);

  useEffect(() => {
    sendPinEvent({
      componentId,
      event: isHovering ? 'hoverEnter' : 'hoverExit',
    });
  }, [isHovering]);

  useVuplex({
    onClick: (callerComponentId) => {
      if (componentId === callerComponentId && _.isFunction(onClick)) onClick();
    },
    onHoverEnter: (callerComponentId) => {
      if (componentId === callerComponentId && _.isFunction(onHoverEnter)) onHoverEnter();
    },
    onHoverExit: (callerComponentId) => {
      if (componentId === callerComponentId && _.isFunction(onHoverExit)) onHoverExit();
    },
  }, [onClick]);

  return null;
};

export default InAppMapPin;
